import { makeAutoObservable } from 'mobx';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import {
  ScanIqPaymentHistoryFilterFormValues,
  ScanIqPaymentHistoryFilters,
  ScanIqPaymentHistoryRecord,
  ScanIqPaymentHistorySortFields,
} from '../interfaces/scanIqPaymentHistoryList';
import { FilterStore } from '../../shared/util-stores';
import { paginationSmallListLimit } from '../../shared/constants/systemConstants';
import { scanIqCustomerPaymentService } from '../services/scanIqCustomerPaymentService';

class ScanIqPaymentHistoryStore {
  historyRecords: ScanIqPaymentHistoryRecord[] = [];
  filterMethods: FilterStore<
    ScanIqPaymentHistoryFilterFormValues,
    ScanIqPaymentHistorySortFields
  >;
  entityId: number | null = null;
  customerId: number | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<
      ScanIqPaymentHistoryFilterFormValues,
      ScanIqPaymentHistorySortFields
    >(this.handleGetScanIqPaymentHistory, {
      elementsPerPage: paginationSmallListLimit,
    });
  }

  setDefaultValues() {
    this.filterMethods.setDefaultValues();

    this.historyRecords = [];
    this.entityId = null;
    this.customerId = null;
  }

  getPaymentHistory(entityId: number, customerId: number) {
    this.setEntityId(entityId);
    this.setCustomerId(customerId);

    return this.filterMethods.getData();
  }

  setEntityId(entityId: number) {
    this.entityId = entityId;
  }

  setCustomerId(customerId: number) {
    this.customerId = customerId;
  }

  private setHistoryRecords(historyRecords: ScanIqPaymentHistoryRecord[]) {
    this.historyRecords = historyRecords;
  }

  private async handleGetScanIqPaymentHistory(filterInfo: ScanIqPaymentHistoryFilters) {
    if (!this.entityId || !this.customerId) {
      throw new Error('entityId or customerId is not defined');
    }

    const response = await scanIqCustomerPaymentService.getPaymentHistory(
      this.entityId,
      this.customerId,
      filterInfo,
    );

    this.setHistoryRecords(response.content);

    return response;
  }
}

const scanIqPaymentHistoryStore = new ScanIqPaymentHistoryStore();
resetAllStore.addResetMethod(scanIqPaymentHistoryStore.setDefaultValues);

export { scanIqPaymentHistoryStore, ScanIqPaymentHistoryStore };
